<template>
  <base-icon
    icon="user"
    :action="goTo"
    title="ステータス変更"
  />
</template>

<script>
import BaseIcon from './Base'

export default {
  components: {
    BaseIcon
  },

  methods: {
    goTo () {
      this.$router.push({ name: 'seating-status' })
    }
  }
}
</script>
